module.exports=function(scope){ return `// Override application language with the selected locale
Locale locale = new Locale("fr");
Configuration config = getBaseContext().getResources().getConfiguration();
config.setLocale(locale);

// Update current configuration
getBaseContext().getResources().updateConfiguration(config, getBaseContext().getResources().getDisplayMetrics());
`};


// WEBPACK FOOTER //
// ./src/resources/code/android/22-localization-setlanguage.java.tpl